import type { ReactElement, SVGProps } from "react";

export function MarketplaceZapIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      {...props}
    >
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  );
}
